<template>
  <div class="app-page model b-modal">
    <vue-headful title="ALICE | Model Setting"></vue-headful>
    <div class="page-header head-row">
      <div class="page-header-content header-elements-md-inline">
        <div class="d-flex">
          <div class="breadcrumb page-title">
            <h4>
              <a href="#" class="breadcrumb-item">
                <em class="fa fa-robot"></em>
                <span class="font-weight-semibold ml-2 text-muted">Knowledge /</span>
              </a>
            </h4>
            <h4>
              <a href="#" class="breadcrumb-item">
                <span class="font-weight-semibold ml-2 breadcrumb-item">Model Setting</span>
              </a>
            </h4>
          </div>
        </div>
      </div>
    </div>
    <div class="column-wrapper">
      <div class="single-page-full">
        <div class="page-content">
          <div class="page-column model-column">
            <div class="column-header">
              <div class="title-row">
                <div class="title-text">Model ({{modelList.length || 0}})</div>
                <div class="title-right-tool">
                  <button class="btn btn-sm btn-primary" @click="quickAddModel">
                    <em class="fa fa-plus mr-2"></em>New Model
                  </button>
                </div>
              </div>
            </div>

            <div class="column-content">
              <draggable :value="modelList" group="model" @change="checkMove">
                <div
                  class="row-item"
                  v-for="model in modelList"
                  :key="model.id"
                  :class="{'selected-row': selectedModelId === model.id}"
                  @click="selectModel(model.id)"
                >
                  <div class="row-item-row">
                    <div class="item-title">{{model.name}}</div>
                    <div class="item-tool">
                      <div
                        class="ml-auto list-icons item-tool-btn"
                      >
                        <em
                          class="fas fa-book-reader ml-auto text-grey-300"
                          :class="{'text-success': model.isOutdated,
                          'disabled-btn': !model.isOutdated}"
                          rel="tooltip"
                          :title="model.isOutdated?'Train model':'Model is up to date.'"
                          @click="toggleTrainModel(model.id, model.isOutdated)"
                        ></em>
                        <em
                          class="fa fa-trash ml-2 text-secondary"
                          rel="tooltip"
                          title="remove model"
                          @click="toggleDeleteModal(true, 'model', model)"
                        ></em>
                      </div>
                    </div>
                  </div>
                  <div class="row-item-row">
                    <div class="item-subtitle">{{model.description || 'No description'}}</div>
                  </div>
                  <div class="row-item-row">
                    <div
                      class="item-smalltitle"
                      v-if="model.lastTrainedAt"
                    >Last trained at {{convertTime(model.lastTrainedAt)}}</div>
                    <div class="item-smalltitle" v-else>Never trained before</div>
                  </div>
                </div>
              </draggable>
            </div>
          </div>
          <div class="page-column category-column">
            <div class="column-header">
              <div class="title-row">
                <div class="title-text">
                  {{selectedModel.name || ''}}
                  <em
                    @click="toggleModelModal(true, 'edit', selectedModel)"
                    class="fa fa-edit edit-btn"
                  ></em>
                </div>
                <div class="title-right-tool">
                  <button class="btn btn-sm btn-primary" @click="quickAddCategory">
                    <em class="fa fa-plus"></em>
                    <span class="ml-2" v-if="!selectedCategory">New Category</span>
                  </button>
                </div>
              </div>
              <div class="subtitle-row">{{selectedModel.description || 'No description'}}</div>
            </div>
            <div class="column-toolbar">
              <div class="toolbar-title">Category ({{filteredCategoryList.length || 0}})</div>
              <div class="toolbar-search">
                <div class="form-group form-group-feedback form-group-feedback-left ml-auto mb-0">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Search"
                    v-model="categorySearchInput"
                  />
                  <div class="form-control-feedback">
                    <em class="fa fa-search"></em>
                  </div>
                </div>
              </div>
            </div>
            <div class="column-content">
              <div class="center-content" v-if="categoryList.length === 0">
                <div>
                  <a href="#" @click="quickAddCategory">
                    <em class="icon-add mr-1"></em> Add new category
                  </a>
                </div>
                <div>
                  <label
                    class="text-muted font-size-sm mt-2"
                  >Please add category and message for completly model</label>
                </div>
              </div>
              <div
                class="row-item"
                v-for="category in filteredCategoryList"
                :key="category.id"
                :class="{'selected-row': selectedCategoryId === category.id}"
                @mouseover="focusCategoryId = category.id"
                @mouseleave="focusCategoryId = ''"
                @click="selectCategory(category.id)">
                <div class="row-item-row">
                  <div class="item-text">
                    <em
                      v-if="category.count === 0"
                      class="fa fa-exclamation-triangle text-orange-300 mr-2"
                      rel="tooltip"
                      title="must have at least one message"
                    ></em>
                    <em v-else class="fa fa-list"></em>
                    <span>{{category.name}}</span>
                  </div>
                  <div class="item-tool">
                    <div
                      class="ml-auto list-icons item-tool-btn"
                      @click.stop="toggleDeleteModal(true, 'category', category)"
                      v-show="focusCategoryId === category.id"
                    >
                      <em
                        class="fa fa-trash ml-2 text-secondary"
                        rel="tooltip"
                        title="remove category"
                      ></em>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <slide-x-right-transition>
            <div class="page-column question-column" v-if="selectedCategoryId && selectedCategory">
              <div class="column-header">
                <div class="title-row">
                  <div class="title-text">
                    {{selectedCategory.name || ''}}
                    <em
                      @click="toggleCategoryModal(true, 'edit', selectedCategory)"
                      class="fa fa-edit edit-btn"
                    ></em>
                  </div>
                </div>
              </div>
              <div class="column-toolbar">
                <div class="toolbar-title">Messages ({{filteredQuestionList.length || 0}})</div>
                <div class="toolbar-search d-flex justify-content-end align-items-center">
                  <div class="form-group form-group-feedback form-group-feedback-left mb-0">
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      placeholder="Search"
                      v-model="questionSearchInput"
                    />
                    <div class="form-control-feedback">
                      <em class="fa fa-search"></em>
                    </div>
                  </div>
                  <i class="gg-sort-az" @click="sortDataMessages" :class="{'active': !statusDataSort}"></i>
                </div>
              </div>
              <div class="column-toolbar">
                <div class="toolbar-form">
                  <div class="input-group">
                    <div class="form-group-feedback">
                      <input
                        type="text"
                        class="form-control form-control-sm alpha-grey"
                        placeholder="New message"
                        v-model="quickAddQuestionInput"
                        @keyup.enter="quickAddQuestion"
                      />
                    </div>
                    <div class="input-group-append">
                      <button
                        type="submit"
                        class="btn btn-primary btn-sm"
                        @click="quickAddQuestion"
                      >
                        <em class="fa fa-plus"></em>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="column-content">
                <div
                  v-if="trainedMessages &&
                  trainedMessages.questions &&
                  trainedMessages.questions.length === 0"
                  class="text-center"
                >
                  <label
                    class="text-muted font-size-sm mt-2"
                  >Please add message to complete the model</label>
                </div>
                <div class="row-item" v-for="question in filteredQuestionList" :key="question.id"
                     @mouseover="focusTrainedMessageId = question.id"
                     @mouseleave="focusTrainedMessageId = ''">
                  <div class="row-item-row">
                    <div class="item-text">
                      <em class="icon-file-text2"></em>
                      <span>{{question.question}}</span>
                      <i class="fas fa-info-circle ml-1" style="color: #999;" data-toggle="popover" data-placement="right" data-html="true" :data-content="question.formattedDate"></i>
                      <span
                        class="badge bg-orange-300 ml-2"
                        v-if="question.status !== 'TRAINED'"
                      >wait for training</span>
                    </div>
                    <div class="item-tool">
                      <div v-show="focusTrainedMessageId === question.id"
                        class="ml-auto list-icons item-tool-btn"
                        @click.stop="toggleDeleteModal(true, 'question', question)"
                      >
                        <em
                          class="fa fa-trash ml-2 text-secondary"
                          rel="tooltip"
                          title="remove question"
                        ></em>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </slide-x-right-transition>
        </div>
      </div>
    </div>
    <div class="modal general-card-modal" :class="{'is-active': modelModal.open}">
      <div class="modal-background"></div>
      <div class="modal-content b-card">
        <div class="card no-margin">
          <div class="card-title">
            <span v-if="modelModal.mode === 'add'">New Model</span>
            <span v-if="modelModal.mode === 'edit'">Edit Model</span>
          </div>
          <div class="columns is-mobile card-form">
            <div class="column">
              <div class="field">
                <div class="label">Model Name</div>
                <div class="control is-expanded">
                  <input
                    type="text"
                    placeholder="Enter model name ... e.g. promotion, tracking, etc."
                    class="input"
                    v-model.trim="modelModal.name"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="columns is-mobile card-form">
            <div class="column">
              <div class="field">
                <div class="label">Model Description</div>
                <div class="control is-expanded">
                  <textarea
                    class="textarea"
                    placeholder="Enter some text that describe this model."
                    rows="3"
                    v-model="modelModal.description"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="card-action">
            <button class="button is-primary" @click="saveModelModal" :disabled="invalidModelModal">
              <span v-if="modelModal.mode === 'add'">Add</span>
              <span v-if="modelModal.mode === 'edit'">Save</span>
            </button>
            <button class="button is-white" @click="toggleModelModal(false)">Cancel</button>
          </div>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close"
              @click="toggleModelModal(false)"></button>
    </div>
    <div class="modal general-card-modal" :class="{'is-active': deleteModal.open}">
      <div class="modal-background"></div>
      <div class="modal-content b-card">
        <div class="card no-margin">
          <div class="card-title">
            <span v-if="deleteModal.mode === 'model'">Delete Model</span>
            <span v-if="deleteModal.mode === 'category'">Delete Category</span>
            <span v-if="deleteModal.mode === 'question'">Delete Question</span>
          </div>
          <div class="columns is-mobile card-form">
            <div class="column" v-if="deleteModal.mode === 'question'">
              <span>
                Are you sure to delete {{deleteModal.mode}} "{{deleteModal.targetName}}".&nbsp;
                This process cannot be undone.
              </span>
            </div>
            <div class="column" v-else>
              <span>
                You are about to delete {{deleteModal.mode}} "{{deleteModal.targetName}}".&nbsp;
                If you process with this action,&nbsp;
              </span>
              <span
                v-if="deleteModal.mode === 'model'"
              >all categories and messages of this model will be deleted.</span>
              <span
                v-if="deleteModal.mode === 'category'"
              >all messages of this category will be deleted.</span>
            </div>
          </div>
          <div class="card-action">
            <button class="button is-danger" @click="confirmDeleteModal">
              <span>Delete</span>
            </button>
            <button class="button is-white" @click="toggleDeleteModal(false)">Cancel</button>
          </div>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close"
              @click="toggleDeleteModal(false)"></button>
    </div>
    <div class="modal general-card-modal" :class="{'is-active': categoryModal.open}">
      <div class="modal-background"></div>
      <div class="modal-content b-card">
        <div class="card no-margin">
          <div class="card-title">
            <span v-if="categoryModal.mode === 'add'">New Category</span>
            <span v-if="categoryModal.mode === 'edit'">Edit Category</span>
          </div>
          <div class="columns is-mobile card-form">
            <div class="column">
              <div class="field">
                <div class="label">Category Name</div>
                <div class="control is-expanded">
                  <input
                    type="text"
                    placeholder="Enter category name ... e.g. promotion detail, question, etc."
                    class="input"
                    v-model.trim="categoryModal.name"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="card-action">
            <button
              class="button is-primary"
              @click="saveCategoryModal"
              :disabled="invalidCategoryModal"
            >
              <span>Save</span>
            </button>
            <button class="button is-white" @click="toggleCategoryModal(false)">Cancel</button>
          </div>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close"
              @click="toggleCategoryModal(false)">
      </button>
    </div>
  </div>
</template>
<script src="https://code.jquery.com/jquery-3.3.1.slim.min.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.7/umd/popper.min.js"></script>
<script>
import { mapGetters, mapActions } from 'vuex';
import { SlideXRightTransition } from 'vue2-transitions';
import { DateTime } from 'luxon';
import moment from 'moment';
import draggable from 'vuedraggable';
import alice from '../../alice-api';

export default {
  name: 'model-setting',
  components: {
    draggable,
    SlideXRightTransition,
  },
  data() {
    return {
      categorySearchInput: '',
      questionSearchInput: '',
      selectedModelId: '',
      selectedCategoryId: '',
      categoryNameInput: '',
      quickAddQuestionInput: '',
      modelModal: {
        open: false,
        mode: 'add',
        id: '',
        name: '',
        description: '',
      },
      deleteModal: {
        open: false,
        mode: 'model',
        id: '',
      },
      categoryModal: {
        open: false,
        mode: 'add',
        id: '',
        name: '',
      },
      focusCategoryId: '',
      focusTrainedMessageId: '',
      statusDataSort: true,
    };
  },
  mounted() {
    this.loadModelList().then((data) => {
      if (data && data[0]) {
        this.selectModel(data[0].id);
      }
    });
  },
  methods: {
    ...mapActions({
      loadModelList: 'model/loadModelList',
      loadCategoryList: 'model/loadCategoryList',
      loadTrainedMessageList: 'model/loadTrainedMessageList',
      createModel: 'model/createModel',
      updateModel: 'model/updateModel',
      deleteModel: 'model/deleteModel',
      createCategory: 'model/createCategory',
      updateCategory: 'model/updateCategory',
      deleteCategory: 'model/deleteCategory',
      createQuestion: 'train/createQuestion',
      deleteTrainedMessage: 'train/deleteTrainedMessage',
      checkMessageStatus: 'train/checkMessageStatus',
      trainModel: 'train/trainModel',
    }),
    async checkMove(evt) {
      const { element, newIndex, oldIndex } = evt.moved;
      const modelArr = [...this.modelList];
      modelArr.splice(oldIndex, 1); // remove from oldIndex
      modelArr.splice(newIndex, 0, element); // add to newIndex
      const modelIdList = modelArr.map((item) => item.id);
      await alice.updateModelOrder(modelIdList);
      this.loadModelList().then((data) => {
        if (data && data[0]) {
          this.selectModel(data[0].id);
        }
      });
    },
    selectModel(modelId) {
      if (this.selectedModel) {
        if (this.selectedModel.id !== modelId) {
          this.selectedModelId = modelId;
          this.reloadCategory(modelId);
        }
      } else {
        this.selectedModelId = modelId;
        this.reloadCategory(modelId);
      }
    },
    reloadCategory(modelId) {
      this.selectedCategoryId = '';
      this.loadCategoryList({ modelId }).then(() => {});
    },
    selectCategory(categoryId) {
      const model = this.selectedModel;
      const modelId = model.id;
      this.selectedCategoryId = categoryId;
      this.loadTrainedMessageList({ modelId, categoryId }).then(() => {});
    },
    convertTime(time) {
      let result = 'N/A';
      if (time) {
        result = moment(time).format('DD/M/YYYY HH:mm');
      }
      return result;
    },
    async toggleTrainModel(modelId, outdated) {
      if (outdated) {
        try {
          await this.trainModel({ modelId });
          this.$buefy.toast.open({
            type: 'is-success',
            message: 'Model trained.',
            position: 'is-bottom',
          });
          await this.loadModelList();
          return true;
        } catch (e) {
          // console.log(e);
          if (e.response) {
            if (e.response.status === 400) {
              this.$buefy.toast.open({
                type: 'is-danger',
                message: 'Model training failed. Please add enough keywords to every category.',
                position: 'is-bottom',
                duration: 3000,
              });
              return false;
            }
          }
          this.$buefy.toast.open({
            type: 'is-danger',
            message: 'Model training failed. Unknown error occurred.',
            position: 'is-bottom',
            duration: 3000,
          });
        }
      }
      return false;
    },
    toggleModelModal(state, mode, data) {
      if (state) {
        if (mode === 'add') {
          this.modelModal.id = '';
          this.modelModal.name = '';
          this.modelModal.description = '';
        }
        if (mode === 'edit') {
          this.modelModal.id = data.id;
          this.modelModal.name = data.name;
          this.modelModal.description = data.description;
        }
      }
      if (mode) {
        this.modelModal.mode = mode;
      }
      this.modelModal.open = state;
    },
    async saveModelModal() {
      const modelData = {
        name: this.modelModal.name,
        description: this.modelModal.description,
      };
      try {
        if (this.modelModal.mode === 'add') {
          await this.createModel({ modelData });
          await this.loadModelList();
          this.$buefy.toast.open({
            type: 'is-success',
            message: 'Model added.',
            position: 'is-bottom',
          });
        } else if (this.modelModal.mode === 'edit') {
          const modelId = this.modelModal.id;
          await this.updateModel({ modelId, modelData });
          await this.loadModelList();
          this.$buefy.toast.open({
            type: 'is-success',
            message: 'Model information updated.',
            position: 'is-bottom',
          });
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status === 409) {
            this.$buefy.toast.open({
              type: 'is-danger',
              message: 'Model name is already existed.',
              position: 'is-bottom',
            });
          }
        }
      } finally {
        this.toggleModelModal(false);
      }
    },
    toggleDeleteModal(state, mode, data) {
      if (state) {
        if (mode === 'model') {
          this.deleteModal.modelId = data.id;
          this.deleteModal.targetName = data.name;
        } else if (mode === 'category') {
          this.deleteModal.modelId = this.selectedModelId;
          this.deleteModal.categoryId = data.id;
          this.deleteModal.targetName = data.name;
        } else if (mode === 'question') {
          this.deleteModal.modelId = this.selectedModelId;
          this.deleteModal.categoryId = this.selectedCategoryId;
          this.deleteModal.questionId = data.id;
          this.deleteModal.targetName = data.question;
        }
      }
      if (mode) {
        this.deleteModal.mode = mode;
      }
      this.deleteModal.open = state;
    },
    async confirmDeleteModal() {
      const {
        mode, modelId, categoryId, questionId,
      } = this.deleteModal;
      if (mode === 'model') {
        try {
          await this.deleteModel({ modelId });
          this.selectedModelId = '';
          this.$buefy.toast.open({
            type: 'is-success',
            message: 'Model deleted.',
            position: 'is-bottom',
          });
          this.loadModelList().then((data) => {
            if (data && data[0]) {
              this.selectModel(data[0].id);
            }
          });
        } catch (e) {
          this.$buefy.toast.open({
            type: 'is-danger',
            message: 'Model delete failed.',
            position: 'is-bottom',
          });
        }
        this.deleteModal.open = false;
      } else if (mode === 'category') {
        try {
          await this.deleteCategory({ modelId, categoryId });
          this.$buefy.toast.open({
            type: 'is-success',
            message: 'Category deleted.',
            position: 'is-bottom',
          });
          await this.loadModelList();
          await this.loadCategoryList({ modelId });
        } catch (e) {
          this.$buefy.toast.open({
            type: 'is-danger',
            message: 'Category delete failed.',
            position: 'is-bottom',
          });
        }
        this.deleteModal.open = false;
      } else if (mode === 'question') {
        try {
          await this.deleteTrainedMessage({ modelId, categoryId, questionId });
          this.$buefy.toast.open({
            type: 'is-success',
            message: 'Question deleted.',
            position: 'is-bottom',
          });
          await this.loadModelList();
          await this.loadCategoryList({ modelId });
          this.loadTrainedMessageList({ modelId, categoryId }).then(() => {});
        } catch (e) {
          this.$buefy.toast.open({
            type: 'is-danger',
            message: 'Question delete failed.',
            position: 'is-bottom',
          });
        }
        this.deleteModal.open = false;
      }
    },
    async newCategory() {
      const modelId = this.selectedModelId;
      const categoryData = {
        name: this.categoryNameInput,
      };
      try {
        await this.createCategory({ modelId, categoryData });
        this.categoryNameInput = '';
      } catch (e) {
        if (e.response && e.response.status === 409) {
          this.$buefy.toast.open({
            type: 'is-danger',
            message: 'Category name is already existed.',
            position: 'is-bottom',
          });
        }
      }
      await this.loadCategoryList({ modelId });
    },
    toggleCategoryModal(state, mode, category) {
      if (state) {
        if (mode === 'add') {
          this.categoryModal.id = '';
          this.categoryModal.name = '';
        } else if (mode === 'edit') {
          this.categoryModal.id = category.id;
          this.categoryModal.name = category.name;
        }
      }
      if (mode) {
        this.categoryModal.mode = mode;
      }
      this.categoryModal.open = state;
    },
    async saveCategoryModal() {
      const modelId = this.selectedModelId;
      const categoryId = this.categoryModal.id;
      const categoryData = {
        name: this.categoryModal.name,
      };
      try {
        if (this.categoryModal.mode === 'add') {
          await this.createCategory({ modelId, categoryData });
          this.toggleCategoryModal(false);
          this.$buefy.toast.open({
            type: 'is-success',
            message: 'New category added.',
            position: 'is-bottom',
          });
        } else if (this.categoryModal.mode === 'edit') {
          await this.updateCategory({ modelId, categoryId, categoryData });
          this.toggleCategoryModal(false);
          this.$buefy.toast.open({
            type: 'is-success',
            message: 'Category information updated.',
            position: 'is-bottom',
          });
        }
      } catch (e) {
        this.toggleCategoryModal(false);
        if (e.response) {
          if (e.response.status === 409) {
            this.$buefy.toast.open({
              type: 'is-danger',
              message: 'Category name is already existed.',
              position: 'is-bottom',
            });
          }
        }
        return false;
      }
      await this.loadCategoryList({ modelId });
      return true;
    },
    toggleCategoryAndNavigate(categoryId) {
      // console.log('TOGGLE category', categoryId);
      this.setSelectedTrainModelId({ modelId: this.selectedModelId });
      this.setSelectedTrainCategoryId({ categoryId });
      this.$router.push({ name: 'train' });
    },
    quickAddQuestion() {
      // Check if had
      const modelId = this.selectedModelId;
      const message = this.quickAddQuestionInput.trim() || '';
      if (message && message.length > 0) {
        this.checkMessageStatus({ modelId, message }).then((result) => {
          // console.log(result);
          if (result.status && result.status[modelId] && result.status[modelId].status === 'NEW') {
            this.addQuestion(this.selectedModelId, this.selectedCategoryId, message);
          } else if (
            result.status
            && result.status[modelId]
            && result.status[modelId].categoryId
            && result.status[modelId].categoryId === this.selectedCategoryId
          ) {
            // Check if had in this or other category
            this.$buefy.toast.open({
              type: 'is-danger',
              message: 'Cannot add this message because it is already in this category.',
              position: 'is-bottom',
            });
          } else {
            this.$buefy.toast.open({
              type: 'is-danger',
              message: 'Cannot add this message because it belongs to other category.',
              position: 'is-bottom',
            });
          }
        });
      } else {
        this.$buefy.toast.open({
          type: 'is-danger',
          message: 'Message cannot be empty.',
          position: 'is-bottom',
        });
      }
    },
    addQuestion(modelId, categoryId, message) {
      this.createQuestion({ modelId, categoryId, message })
        .then(() => {
          this.quickAddQuestionInput = '';
          this.loadModelList().then(() => {});
          this.loadCategoryList({ modelId }).then(() => {});
          this.loadTrainedMessageList({ modelId, categoryId }).then(() => {});
        })
        .catch((e) => {
          if (e.response.status === 409) {
            this.$buefy.toast.open({
              type: 'is-warning',
              message: `Cannot add duplicate message ${message} in to train list.`,
              position: 'is-bottom',
              duration: 3500,
            });
          } else {
            // console.log(e, e.response);
            this.$buefy.toast.open({
              type: 'is-danger',
              message: 'Unexpected error occurred.',
              position: 'is-bottom',
              duration: 3500,
            });
          }
        });
    },
    findSimilarAndSuggestName(list, target, splitter) {
      let maxCount = 0;
      let firstFound = false;
      list.forEach((obj) => {
        if (obj.name.indexOf(target) > -1) {
          const testCount = parseInt(
            obj.name
              .split(target)
              .pop()
              .trim()
              .replace(splitter, ''),
            10,
          );
          // eslint-disable-next-line no-restricted-globals
          if (isNaN(testCount)) {
            // First one
            firstFound = true;
          } else if (testCount > maxCount) {
            maxCount = testCount;
          }
        }
      });
      if (maxCount || firstFound) {
        return `${target}${splitter}${+maxCount + 1}`;
      }
      return target;
    },
    async quickAddModel() {
      const modelData = {
        name: 'New model name',
        description: 'Please describe model',
      };
      // Suggest name with number if duplicate
      const suggestedName = this.findSimilarAndSuggestName(this.modelList, 'New model name', ' ');
      modelData.name = suggestedName;
      // console.log('Adding', modelData.name);
      try {
        const result = await this.createModel({ modelData });
        await this.loadModelList();
        this.$buefy.toast.open({
          type: 'is-success',
          message: 'Model added.',
          position: 'is-bottom',
        });
        this.selectModel(result.id);
        // Edit name ---
        this.toggleModelModal(true, 'edit', this.selectedModel);
      } catch (e) {
        // console.log('Cannot add model');
      }
    },
    async quickAddCategory() {
      const modelId = this.selectedModelId;
      const categoryData = {
        name: 'New_category_name',
      };
      // Suggest name with number if duplicate
      const suggestedName = this.findSimilarAndSuggestName(
        this.categoryList,
        'New_category_name',
        '_',
      );
      categoryData.name = suggestedName;
      try {
        const result = await this.createCategory({ modelId, categoryData });
        this.reloadCategory(modelId);
        this.$buefy.toast.open({
          type: 'is-success',
          message: 'New category added.',
          position: 'is-bottom',
        });
        // console.log('RESULT', result);
        this.selectCategory(result.id);
        setTimeout(() => {
          this.toggleCategoryModal(true, 'edit', this.selectedCategory);
        }, 500);
      } catch (e) {
        // console.log('Cannot add category');
      }
    },
    setdateformat(question) {
      const date = question.lastActivityAt ? question.lastActivityAt : question.updatedAt;
      const currentDateTime = DateTime.now().setZone("Asia/Bangkok");
      const localDateTime = DateTime.fromISO(date).setZone("Asia/Bangkok");
      const diffInDays = currentDateTime.diff(localDateTime, ["day"]).toObject().days;
      const username = question.lastActivityByUsername ? question.lastActivityByUsername : "Unknown";
      let dateString = `<b>${username}</b> updated at:`;
      if (diffInDays > 1.0) {
        // DATE STRING FORMAT
        // return localDateTime.toFormat("dd/LL/yyyy HH:mm:ss");
        dateString = `${dateString} ${localDateTime.toFormat("dd/LL/yyyy HH:mm")}`;
      } else {
        // RELATIVE WORD
        // return localDateTime.toRelative();
        dateString = `${dateString} ${localDateTime.toRelative()}`;
      }
      return dateString;
    },
    sortDataMessages() {
      function sortFunctionasc(a,b){
        var dateA = new Date(a.lastActivityAt ? a.lastActivityAt : a.updatedAt).getTime();
        var dateB = new Date(b.lastActivityAt ? b.lastActivityAt : b.updatedAt).getTime();
        return dateA > dateB ? 1 : -1;
      }
       function sortFunctiondesc(a,b){
        var dateA = new Date(a.lastActivityAt ? a.lastActivityAt : a.updatedAt).getTime();
        var dateB = new Date(b.lastActivityAt ? b.lastActivityAt : b.updatedAt).getTime();
        return dateA > dateB ? -1 : 1;
      }
      this.statusDataSort = !this.statusDataSort;
      const sortData =  this.statusDataSort ? this.filteredQuestionList.sort(sortFunctionasc) : this.filteredQuestionList.sort(sortFunctiondesc);
      return sortData;
    }
  },
  computed: {
    ...mapGetters({
      modelList: 'model/modelList',
      categoryList: 'model/categoryList',
      trainedMessages: 'model/trainedMessages',
      selectedModelIdTrain: 'train/selectedModelId',
      selectedCategoryIdTrain: 'train/selectedCategoryId',
    }),
    selectedModel() {
      const list = this.modelList;
      if (this.selectedModelId) {
        return list.find((model) => model.id === this.selectedModelId);
      }
      return {};
    },
    selectedCategory() {
      const list = this.categoryList;
      if (this.selectedCategoryId) {
        return list.find((category) => category.id === this.selectedCategoryId);
      }
      return {};
    },
    filteredCategoryList() {
      if (this.categoryList && this.categoryList.length > 0) {
        return this.categoryList.filter((data) => {
          const searchInput = this.categorySearchInput.trim().toLowerCase();
          const target = data.name.toLowerCase();
          return target.includes(searchInput);
        });
      }
      return [];
    },
    filteredQuestionList() {
      if (
        this.trainedMessages
        && this.trainedMessages.questions
        && this.trainedMessages.questions.length > 0
      ) {
        this.statusDataSort = true;
        setTimeout(() => {
           $('[data-toggle="popover"]').popover({ trigger: 'hover' });
        }, 1000);
        return this.trainedMessages.questions.filter((data) => {
          const searchInput = this.questionSearchInput.toLowerCase();
          const target = data.question.toLowerCase();
          return target.indexOf(searchInput) > -1;
        }).map((data) => {
          data.formattedDate = this.setdateformat(data);
          return data;
        });
      }
      return [];
    },
    invalidModelModal() {
      const { name } = this.modelModal;
      return !name || name.length === 0;
    },
    invalidCategoryModal() {
      const { name } = this.categoryModal;
      return !name || name.length === 0;
    },
  },
};
</script>


<style lang="scss" scoped>
.model {
  .button,
  .input {
    border-radius: 5px;
  }
  .column-wrapper {
    padding: 10px 15px 15px 15px;
    .single-page-full {
      border: 1px solid #ddd;
      border-radius: 3px;
      .page-column {
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow: hidden;
        .column-header {
          padding: 15px;
          border-bottom: 1px solid #eee;
          min-height: 90px;
          .title-row {
            display: flex;
            justify-content: space-between;
            .title-text {
              font-size: 1rem;
              line-height: 2rem;
              .edit-btn {
                cursor: pointer;
                color: #555;
                font-size: 0.9rem;
                margin-left: 5px;
              }
            }
          }
          .subtitle-row {
            max-height: 60px;
            overflow: auto;
            font-size: 0.7rem;
            color: #666;
          }
        }
        .column-toolbar {
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #eee;
          min-height: 40px;
          .toolbar-form {
            padding: 3px;
            width: 100%;
          }
          .toolbar-title {
            font-size: 0.9rem;
            line-height: 1.2rem;
            padding: 10px;
            font-weight: 400;
          }
          .toolbar-search {
            min-width: 10%;
            padding: 3px;
            .form-group-feedback-left .form-control-feedback {
              font-size: 0.7rem;
              color: #555;
            }
          }
        }
        .column-content {
          flex: 1 1 auto;
          overflow-y: auto;
          overflow-x: hidden;
          position: relative;
          .row-item {
            border-bottom: 1px solid #eee;
            padding: 10px;
            border-left: 3px solid transparent;
            &.selected-row {
              border-left: 3px solid #0176bd;
              background-color: rgba(32, 150, 243, 0.09);
              .row-item-row {
                .item-title,
                .item-text {
                  color: #0176bd;
                }
              }
            }
            .row-item-row {
              display: flex;
              justify-content: space-between;
              .item-title {
                color: #333;
                font-weight: 500;
                font-size: 1rem;
                line-height: 1rem;
              }
              .item-text {
                color: #333;
                font-size: 0.8rem;
                line-height: 1.2rem;
                em {
                  margin-right: 10px;
                }
              }
              .item-subtitle {
                margin-top: 3px;
                color: #666;
                font-size: 0.75rem;
              }
              .item-smalltitle {
                margin-top: 10px;
                color: #aaa;
                font-size: 0.7rem;
              }
              .item-tool {
                flex: 0 0 auto;
                height: 20px;
                overflow: hidden;
                .item-tool-btn {
                  cursor: pointer;
                  .disabled-btn {
                    cursor: not-allowed;
                  }
                  .fa-trash {
                    font-size: 1rem;
                    line-height: 20px;
                  }
                }
              }
            }
          }
          .center-content {
            width: 100%;
            top: 50%;
            text-align: center;
            position: absolute;
          }
        }
      }
      .model-column {
        flex: 0 0 25%;
        min-width: 200px;
        border-right: 1px solid #eee;
      }
      .category-column {
        flex: 1 1 auto;
        min-width: 20%;
      }
      .question-column {
        flex: 1 1 auto;
        min-width: 30%;
        max-width: 40%;
        border-left: 1px solid #eee;
      }
    }
  }
  .column-wrapper .column-toolbar{
    .toolbar-search{
      width: 40%;
      gap: 10px;
      padding: 10px !important;
    }
  }
}
.gg-sort-az,
.gg-sort-az::after,
.gg-sort-az::before {
    display: block;
    box-sizing: border-box;
    height: 2px;
    border-radius: 4px;
    background: currentColor
}
.gg-sort-az {
    position: relative;
    transform: scale(var(--ggs,1));
    width: 8px
}
.gg-sort-az::after,
.gg-sort-az::before {
    content: "";
    position: absolute
}
.gg-sort-az::before {
    width: 12px;
    top: -4px;
    left: -2px
}
.gg-sort-az::after {
    width: 4px;
    top: 4px;
    left: 2px
}
.gg-sort-az.active {
  color: #2196f3;
}
</style>
